export default __webpack_public_path__ + "static/media/Background_00268.a6f57ad6.png";